exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notificationTable .el-table .el-table__row {\n  cursor: pointer;\n}\n.notificationTable .el-table .el-table__header-wrapper .el-table__header .has-gutter .el-table__cell {\n  border: none;\n}\n.notificationTable .el-table .el-table__header-wrapper .el-table__header .has-gutter .el-table__cell .cell {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  text-align: left !important;\n  color: #200e32 !important;\n}\n.notificationTable .el-table .el-table__empty-block {\n  display: none;\n}\n.notificationTable .el-table .el-table__body-wrapper .el-table__cell {\n  padding: 18px 0 !important;\n}\n", ""]);

// exports
